

  function lmFacetColorsToImages()
  {
    let smHidden = false;
	  const lmAssetURL = '//latchedmama.com/cdn/shop/files/ImageName?v=65426';
   
    //convert an image submenu to an image link in the megamenu
    document.querySelectorAll('input[name="filter.v.m.filters.color"]').forEach((cb) => {

      //generate the image name from the checkbox value (recreate the handle)
      const keyName = cb.value.toLowerCase().replace('/[^a-z0-9 ]/gi/','').replace('/ /g','-');
      const imageName = 'filter-color-' + keyName + '.png';
      const imageURL = lmAssetURL.replace('ImageName',imageName);

      //designated our color list for css
      cb.closest('ul').classList.add('filter-color-list');

      //
      const lbl = cb.parentNode;
      lbl.style.background = 'url("' + imageURL + '")';
      lbl.setAttribute('title',cb.value);
      
      if (cb.checked) lbl.classList.add('is-selected');

      //match the class to the checkbox state
      cb.addEventListener('change',(evt) => lbl.classList.toggle('is-selected') );  

      const listItem = cb.parentNode.parentNode;
      listItem.classList.remove('show-more-item','hidden');

      //if we haven't done it yet, hide the show more btn for colors
      if (smHidden == false)
      {
        const detailCont = cb.closest('details');
        const smBtn = detailCont.querySelector('show-more-button');
        if (smBtn)
				{
					smBtn.style.display = 'none';
        	smHidden = true;
				}
      }
    });

  };
  

  function lmGetSizeOrder()
  { 
		const sizeOrder = [
			"XXS",
			"XS",
			"XS/S",
			"S",
			"M",
			"M/L",
			"L",
			"XL",
			"XL/1X",
			"1X",
			"2X",
			"2X/3X",
			"3X",
			"4X",
			"4X/5X",
			"One Size",
			"Petite",
			"Plus",
			"Standard",
			"6 Months",
			"12 Months",
			"18 Months",
    ];

    return sizeOrder;
  } 
    
  function lmFacetSizeOrder()
  {
    const sizeOrder = lmGetSizeOrder();
    const sizeInputs = document.querySelectorAll('input[name="filter.v.m.filters.size"]');
    let displayUpdated = false;
    
    //convert an image submenu to an image link in the megamenu
    sizeInputs.forEach( (cb,idx) => {

      const listItem = cb.parentNode.parentNode;
           
      const orderIdx = sizeOrder.indexOf(cb.getAttribute('value'));
      if (orderIdx !== -1)
      {
        cb.parentNode.parentNode.style.order = orderIdx;
      }

      //not my favorite but it ensures its set on every
      //list list on the page
      if (displayUpdated == false)
      {
        listItem.parentNode.style.display = 'flex';
        listItem.parentNode.style.flexDirection = 'column';
        displayUpdated = true;
      }
      
     //if not mobile, handle the show-more stuff
      if (!listItem.classList.contains('mobile-facets__item'))
      {
        listItem.classList.remove('show-more-item','hidden');

        /**
        El 2025-04-05
        Leftover code from some other workaround.  Leave here for now in case I broke something
        
        if (orderIdx < 10)
        {
          listItem.classList.remove('show-more-item','hidden');
        }
        else
        {
          listItem.classList.add('show-more-item','hidden');
        }
        */
      }
      
    });

  };


//fire it up
//document.addEventListener("DOMContentLoaded", () => {

document.onreadystatechange = function () {

  if (document.readyState === 'interactive') 
	{
  	lmFacetSizeOrder();
  	lmFacetColorsToImages();

	  document.querySelectorAll('facet-filters-form form').forEach( form => {

	    form.addEventListener('facets:updated',() => {
				lmFacetColorsToImages();
			});
	  });

	}

}
